import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=13119d22&scoped=true&"
import script from "./roles.vue?vue&type=script&lang=js&"
export * from "./roles.vue?vue&type=script&lang=js&"
import style0 from "./roles.vue?vue&type=style&index=0&id=13119d22&prod&scoped=true&lang=css&"
import style1 from "./roles.vue?vue&type=style&index=1&id=13119d22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13119d22",
  null
  
)

export default component.exports